// Guard against silent save-failures.
//
// PostgREST returns `{ data: null, error: null }` when an UPDATE/DELETE matches
// 0 rows — because RLS filtered the row (locked/signed/cross-tenant) or a guard
// like `.eq('status','draft')` no longer matches. No error is raised, so an
// optimistic local mutation would run and the UI would show a phantom "save".
//
// Always force PostgREST to return the affected rows with `.select('id')` on
// mutations, then pass the result through this helper BEFORE mutating local
// state. See docs/business-rules/general.md (G-021) and
// docs/audits/silent-failure-audit-2026-06-02.md.
//
//   const { data, error } = await supabase
//     .from('t').update(payload).eq('id', id).select('id')
//   if (error) throw error
//   assertAffected(data, 'No se pudo guardar. Verifica tus permisos o que el registro siga existiendo.')
//   Object.assign(this.local[idx], payload)   // only after a row is confirmed
//
// 0-row cause disambiguation: if the session died (the write went out anonymous
// because the JWT/refresh token expired), throw a SessionExpiredError instead of
// the caller's generic message, so the user gets an honest "Tu sesión expiró"
// and a redirect to login rather than a misleading "Verifica tus permisos".
import { SessionExpiredError, isSessionDead } from './sessionExpired'

export function assertAffected<T>(data: T[] | null | undefined, msg: string): T[] {
  if (!data || data.length === 0) {
    if (isSessionDead()) throw new SessionExpiredError()
    throw new Error(msg)
  }
  return data
}
